<template>
  <b-dropdown
      v-if="available.length > 0"
      right
      class="ml-auto"
      variant="outline-success"
      :disabled="loading !== null"
  >
    <template #button-content>
      <b-icon icon="download"></b-icon>
      {{ loading !== null ? $t('Exporting...') : $t('Export') }}
    </template>
    <b-dropdown-item
        v-for="item in available"
        :key="item.type"
        :disabled="loading !== null"
        @click="run(item.type)"
    >
      {{ item.label }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import {downloadReturnsExport, getAvailableReturnsExports} from "../../services/returnsExport";

export default {
  name: "ReturnsExportButtons",
  props: {
    // same query as the list: {filter, orderBy, order}
    params: {type: Object, required: true}
  },
  data: () => ({available: [], loading: null}),
  created() {
    getAvailableReturnsExports()
        .then(json => {
          this.available = Array.isArray(json) ? json : [];
        })
        .catch(() => {
          this.available = [];
        });
  },
  methods: {
    async run(type) {
      this.loading = type;
      this.$store.commit('setLoadingAnything', true);
      try {
        await downloadReturnsExport(type, this.params);
      } catch (e) {
        let message;
        if (e.status === 403) {
          message = this.$t('You are not allowed to export this data.');
        } else if (e.status === 422 && e.message) {
          message = e.message;
        } else {
          message = this.$t('Export failed. Please try again later.');
        }
        this.$store.commit('showToast', {title: this.$t('Export'), message: message, type: 'danger'});
      } finally {
        this.loading = null;
        this.$store.commit('setLoadingAnything', false);
      }
    }
  }
}
</script>
